import { Icon } from '@assembly-js/design-system';
import { SvgIconProps } from '@mui/material';

export const SignatureDateIcon = ({ className, style }: SvgIconProps) => (
  <Icon
    icon="calendar"
    className={className}
    style={{ width: '1em', height: '1em', ...style }}
  />
);
